import request from '@/utils/http.js';
import qs from 'qs';

// 获取分类跟子分类
export function getClassAll(options) {
  return request({
    url: `${window.config.api_v1}/dictionary/getClassAll`,
    method: 'GET',
    params: options
  });
}

//因子列表
export function getFactorListByClassId(options) {
  return request({
    url: `${window.config.api_v1}/dictionary/getFactorListByClassId`,
    method: 'GET',
    params: options
  });
}

//请求回测 (多因子)
export function initiateDyzHc(options) {
  return request({
    url: `${window.config.api_v1}/backtest/initiateDyzHc`,
    method: 'GET',
    params: options
  });
}

//保存多因子回测
export function addMyDyzHc(options) {
  return request({
    url: `${window.config.api_v1}/backtest/addMyDyzHc`,
    method: 'POST',
    data: qs.stringify(options)
  });
}

//更新多因子回测
export function updateMyDyzHc(options) {
  return request({
    url: `${window.config.api_v1}/backtest/updateMyDyzHc`,
    method: 'POST',
    data: qs.stringify(options)
  });
}

//保存-多因子策略
export function addMyCl(options) {
  return request({
    url: `${window.config.api_v1}/backtest/addMyCl`,
    method: 'POST',
    data: qs.stringify(options)
  });
}

//编辑-多因子策略
export function updateMyDyzCl(options) {
  return request({
    url: `${window.config.api_v1}/backtest/updateMyDyzCl`,
    method: 'POST',
    data: qs.stringify(options)
  });
}

//行情
export function getFactorHq(options) {
  return request({
    url: `${window.config.api_v1}/quotation/getFactorHq`,
    method: 'GET',
    params: options
  });
}

// 请求回测 (量化交易)
export function initiateLhHc(options) {
  return request({
    url: `${window.config.api_v1}/backtest/initiateLhHc`,
    method: 'POST',
    data: qs.stringify(options)
  });
}
//根据ID查询量化交易回测
export function getLhjyHCById(options) {
  return request({
    url: `${window.config.api_v1}/backtest/getLhjyHCById`,
    method: 'GET',
    params: options
  });
}

// 股票行情服务
export function getStockHq(options) {
  return request({
    url: `${window.config.api_v1}/quotation/getStockHq`,
    method: 'GET',
    params: options
  });
}

// 查询量化交易历史明细  OR  累计收益图
export function backtestTradeQueryDetail(options) {
  return request({
    url: `${window.config.api_v1}/backtest/backtestTradeQueryDetail`,
    method: 'GET',
    params: options
  });
}

// 保存量化交易回测
export function addLhHc(options) {
  return request({
    url: `${window.config.api_v1}/backtest/addLhHc`,
    method: 'POST',
    data: qs.stringify(options)
  });
}

// 更新量化交易回测
export function updateMyLhHc(options) {
  return request({
    url: `${window.config.api_v1}/backtest/updateMyLhHc`,
    method: 'POST',
    data: qs.stringify(options)
  });
}

// 开启模拟交易
export function mockpanelOpen(options) {
  return request({
    url: `${window.config.api_v1}/transaction/mockpanelOpen`,
    method: 'GET',
    params: options
  });
}

// 搜索因子
// export function searchFactors(options) {
//   return request({
//     url: `${window.config.api_v4_new}/api/mobile/home/searchFactors`,
//     method: 'GET',
//     params: options
//   });
// }
export function searchFactors(options) {
  return request({
    url: `${window.config.api_v1}/element/getSearchFactorInfo`,
    method: 'GET',
    params: options
  });
}

//当日股池
export function getDayStockPool(options) {
  return request({
    url: `${window.config.api_v1}/backtest/getDayStockPool`,
    method: 'GET',
    params: options
  });
}

//获取动态组合名称的后缀-=--条数
export function getMyDynamicCount(options = {}) {
  return request({
    url: `${window.config.api_v1}/dynamic/getMyDynamicCount`,
    method: 'GET',
    params: options
  });
}

//添加动态组合
export function addDynamic(options) {
  return request({
    url: `${window.config.api_v1}/dynamic/addDynamic`,
    method: 'POST',
    data: qs.stringify(options)
  });
}

//获取个性化菜单下的因子数据(移动端专用)
export function getMergeIndividuation(options) {
  return request({
    url: `${window.config.api_v1}/dictionary/getMergeIndividuation`,
    method: 'GET',
    params: options
  });
}

//获取调优模版因子信息 (带分页)
export function getTemplateFactor(options) {
  return request({
    url: `${window.config.api_v1}/dictionary/getTemplateFactor`,
    method: 'GET',
    params: options
  });
}

// 获取我的自选因子
export function getMyStockInfo(params = {}) {
  return request({
    url: `${window.config.api_v1}/dictionary/getMyStockInfo`,
    method: 'get',
    params,
    type: 'json'
  });
}

// 获取我的自定义因子
export function getMyCustomFactor(params = {}) {
  return request({
    url: `${window.config.api_v1}/dictionary/getMyCustomFactor`,
    method: 'get',
    params,
    type: 'json'
  });
}

//修改动态组合
export function updateMyDynamic(options) {
  return request({
    url: `${window.config.api_v1}/dynamic/updateMyDynamic`,
    method: 'POST',
    data: qs.stringify(options)
  });
}

//查询因子是否是vip
export function getFactorListIsVip(params = {}) {
  return request({
    url: `${window.config.api_v1}/special/getFactorListIsVip`,
    method: 'get',
    params,
    type: 'json'
  });
}

//请求回测 (多因子)
export function initiateHcByFactor(options) {
  return request({
    url: `${window.config.api_v1}/open/initiateHcByFactor`,
    method: 'GET',
    params: options
  });
}

// 根据因子INDEX查询因子详情信息
export function getFactorByIndexCode(options) {
  return request({
    url: `${window.config.api_v1}/element/getIndexConvertFid`,
    method: 'GET',
    params: options
  });
}

// 因子字典-热门分类
export function getDictionaryHotFactor(options) {
  return request({
    url: `${window.config.api_v1}/Dictionary/getDictionaryHotFactor`,
    method: 'GET',
    params: options
  });
}
